export const examTypes = [
    "Quiz",
    "Assignment",
    "Lab",
    "Activity",
    "Class Participation",
    "Project",
    "Sessional",
    "Final",
];